import React, { useEffect, useState } from "react";
import { Button, Container, FormGroup, Input, Label, Form } from "reactstrap";
import Swal from "sweetalert2";
import axios from "axios";
import Cookies from "universal-cookie";

const CreaCasosJuridica = () => {
  const cookie = new Cookies();

  // Constantes para URLs y valores estáticos
  const TEMAS_API =
    "https://contratosback.azurewebsites.net/api/v1/ObtenerTemas";
  const CREATE_API =
    "https://contratosback.azurewebsites.net/api/v1/CreaSolicitudJuridica";

  // Estados para manejo del formulario y datos
  const [formData, setFormData] = useState({
    idTema: "",
    titulo: "",
    nit: "",
    descripcion: "",
    tieneTicket: "", // Para saber si hay un ticket asociado
    numeroCaso: "", // Para el número de caso
  });
  const [temas, setTemas] = useState([]);

  // Fetch de temas para poblar la lista desplegable
  useEffect(() => {
    const fetchTemas = async () => {
      try {
        const response = await axios.get(TEMAS_API);
        setTemas(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Error al obtener los temas:", error);
      }
    };
    fetchTemas();
  }, []);

  // Manejo de cambios en los inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Enviar formulario
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Crear el objeto JSON con los datos requeridos
    const requestData = {
      IdTema: parseInt(formData.idTema, 10), // Convertir a entero si es necesario
      Titulo: formData.titulo,
      Descripcion: formData.descripcion,
      FechaCreacion: new Date().toISOString(),
      UsuarioCreacion: 1, // Obtener el ID del usuario desde las cookies
      IdEstado: 1,
      Nit: formData.nit,
      TieneTicket: formData.tieneTicket === "si", // Convertir el valor "si"/"no" a booleano
      NumeroCaso: formData.tieneTicket === "si" ? formData.numeroCaso : null, // Solo enviar el número de caso si hay un ticket
    };

    try {
      const response = await axios.post(CREATE_API, requestData, {
        headers: { "Content-Type": "application/json" },
      });

      // Verificar si la respuesta contiene el ID
      if (response.data) {
        const idCaso = response.data; // Reemplazar "id" con el nombre exacto del campo en la respuesta
        Swal.fire({
          title: "Caso creado con éxito",
          icon: "success",
        }).then(() => (window.location.href = `/EvidenciaJuridica/${idCaso}`));
      } else {
        throw new Error("No se recibió el ID del caso creado", response.data);
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "No se pudo crear el caso",
        icon: "error",
      });
      console.error("Error al crear el caso:", error);
    }
  };

  return (
    <Container style={{ padding: 16, maxWidth: 1050 }}>
      <h2>CREACIÓN DE CASO</h2>
      <Form onSubmit={handleSubmit}>
        {/* Tipo de Documento */}
        <FormGroup>
          <Label for="idTema">Tipo de Documento</Label>
          <Input
            type="select"
            name="idTema"
            value={formData.idTema}
            onChange={handleChange}
            required
          >
            <option value="">Seleccione</option>
            {temas.map((tema) => (
              <option key={tema.id} value={tema.id}>
                {tema.descripcion}
              </option>
            ))}
          </Input>
        </FormGroup>

        {/* Nombre del contratante */}
        <FormGroup>
          <Label for="titulo">Nombre del contratante o entidad</Label>
          <Input
            type="text"
            name="titulo"
            value={formData.titulo}
            onChange={handleChange}
            required
          />
        </FormGroup>

        {/* NIT */}
        <FormGroup>
          <Label for="nit">NIT sin Digito de verificación</Label>
          <Input
            type="text"
            name="nit"
            value={formData.nit}
            onChange={handleChange}
            required
          />
        </FormGroup>

        {/* Descripción */}
        <FormGroup>
          <Label for="descripcion">Descripción</Label>
          <Input
            type="textarea"
            name="descripcion"
            value={formData.descripcion}
            onChange={handleChange}
            required
          />
        </FormGroup>

        {/* ¿Tiene ticket asociado? */}
        <FormGroup>
          <Label for="tieneTicket">¿El caso tiene un ticket asociado?</Label>
          <Input
            type="select"
            name="tieneTicket"
            value={formData.tieneTicket}
            onChange={handleChange}
            required
          >
            <option value="">Seleccione</option>
            <option value="si">Sí</option>
            <option value="no">No</option>
          </Input>
        </FormGroup>

        {/* Número de caso (solo si tiene ticket asociado) */}
        {formData.tieneTicket === "si" && (
          <FormGroup>
            <Label for="numeroCaso">Digite su número de caso asociado</Label>
            <Input
              type="text"
              name="numeroCaso"
              value={formData.numeroCaso}
              onChange={handleChange}
              required={formData.tieneTicket == "si"}
            />
          </FormGroup>
        )}

        {/* Botón de enviar */}
        <Button type="submit" color="primary">
          Crear Caso
        </Button>
      </Form>
    </Container>
  );
};

export default CreaCasosJuridica;
